function initMap() {
  const location = { lat: -25.344, lng: 131.036 };
  const map = new google.maps.Map(document.querySelector(`#map`), {
    zoom: 4,
    center: location,
  });
  const marker = new google.maps.Marker({
    position: location,
    map: map,
  });
}

/**
 * This scrolls the page down to the contact us map container when
 * the user makes a location selection.
 */
const setSCrollEvent = (locationButton) => {
  locationButton.forEach((button) => {
    let locationSection = document.querySelector(`${button.dataset.bsTarget}`);

    button.addEventListener(`click`, () => {
      setTimeout(() => {
        locationSection.scrollIntoView();
      }, 200);
    });
  });
};

/**
 * No location is active by default in the php. Sets the first
 * location to active in desktop views.
 */
const setActiveLocation = (locationButton, locationContainer, windowSize) => {
  if (windowSize > 992) {
    locationButton[0].classList.add(`active`);
    locationContainer[0].classList.add(`active`, `show`);
  }
};

/**
 * Allows the accordion content to be collapsed in mobile views when
 * loading into the page, but shows the content in desktop views.
 */
const setMapButtonState = (windowSize) => {
  if (windowSize > 992) {
    let contactUsCollapseMenus =
      document.querySelectorAll(`.accordion-collapse`);

    contactUsCollapseMenus.forEach((menu) => {
      menu.classList.add(`show`);
    });
  }
};

const contactUsBlock = document.querySelector(`.contact-us`);

if (contactUsBlock) {
  let locationButton = document.querySelectorAll(
    `button.button-school-nav-link`
  );
  let contactUsNavContainer = document.querySelector(`.contact-us-nav`);
  let windowSize = document.querySelector(`body`).clientWidth;
  let locationContainer = document.querySelectorAll(
    `.location-contact-us-tab-pane`
  );
  setSCrollEvent(locationButton);
  setMapButtonState(windowSize);
  if (contactUsNavContainer) {
    setActiveLocation(locationButton, locationContainer, windowSize);
  }
}
